import './assets/main.css'
import { createApp, watch } from 'vue'
import { createRouter, createWebHashHistory } from 'vue-router'
import { createPinia } from 'pinia'
import App from './App.vue'
import { useAuthStore } from './stores/authStore.js'

const index = () => import('./components/index.vue')
const tickets = () => import('./components/tickets.vue')
const finance = () => import('./components/finance.vue')
const building_overview = () => import('./components/building_overview.vue')
const building_view = () => import('./components/building_view.vue')
const building_edit = () => import('./components/building_edit.vue')
const operatingcosts = () => import('./components/operatingcosts.vue')
const operatingcostsunit = () => import('./components/operatingcostsunit.vue')
const tenant_overview = () => import('./components/tenant_overview.vue')
const tenant_singleview = () => import('./components/tenant_singleview.vue')
const Login = () => import('./components/Login.vue')
const addbankaccount = () => import('./components/addbankaccount.vue')
const updatebankaccount = () => import('./components/updatebankaccount.vue')
const booking_category_edit = () => import('./components/booking_category_edit.vue')
const documents = () => import('./components/documents.vue')
const rental_overview = () => import('./components/building_rent_overview.vue')
const rental_overview_edit = () => import('./components/building_rent_overview_edit.vue')
const building_snow_waste_plan = () => import('./components/building_snow_waste_plan.vue')
const building_taxes = () => import('./components/building_taxes.vue')
const building_unit_wohnungsgeberbestaetigung = () => import('./components/building_unit_wohnungsgeberbestaetigung.vue')
const building_unit_mietbescheinigung = () => import('./components/building_unit_mietbescheinigung.vue')

const routes = [
    { path: '/', component: index, name: 'index', meta: { requiresAuth: true } },
    { path: '/tickets', component: tickets, name: 'tickets', meta: { requiresAuth: true } },
    { path: '/finance', component: finance, name: 'finance', meta: { requiresAuth: true } },
    { path: '/finance/building/:id', component: finance, name: 'finance_building', meta: { requiresAuth: true } },
    { path: '/building/:id/documents', component: documents, name: 'building_documents', meta: { requiresAuth: true } },
    { path: '/building/:id/snow_waste', component: building_snow_waste_plan, name: 'building_snow_waste_plan', meta: { requiresAuth: true } },
    { path: '/finance/building/:id/unit/:unitid', component: finance, name: 'finance_building_unit', meta: { requiresAuth: true } },
    { path: '/operatingcosts/:id', component: operatingcosts, name: 'operatingcosts', meta: { requiresAuth: true } },
    { path: '/operatingcosts/:id/unit/:unitid', component: operatingcostsunit, name: 'operatingcostsunit', meta: { requiresAuth: true } },
    { path: '/building', component: building_overview, name: 'building_overview', meta: { requiresAuth: true } },
    { path: '/building/:id', component: building_view, name: 'building_view', meta: { requiresAuth: true } },
    { path: '/building/:id/rentals', component: rental_overview, name: 'rental_overview', meta: { requiresAuth: true } },
    { path: '/building/:id/rentals/edit', component: rental_overview_edit, name: 'rental_overview_edit', meta: { requiresAuth: true } },
    { path: '/building/:id/edit', component: building_edit, name: 'building_edit', meta: { requiresAuth: true } },
    { path: '/building/:id/unit/:unitid/confirmation', component: building_unit_wohnungsgeberbestaetigung, name: 'building_unit_wohnungsgeberbestaetigung', meta: { requiresAuth: true } },
    { path: '/building/:id/unit/:unitid/certificate', component: building_unit_mietbescheinigung, name: 'building_unit_mietbescheinigung', meta: { requiresAuth: true } },
    { path: '/building/:id/taxes/:year', component: building_taxes, name: 'building_taxes', meta: { requiresAuth: true } },
    { path: '/tenants', component: tenant_overview, name: 'tenant_overview', meta: { requiresAuth: true } },
    { path: '/tenants/:id', component: tenant_singleview, name: 'tenant_view', meta: { requiresAuth: true } },
    { path: '/login', component: Login, name: 'login' },
    { path: '/addbankaccount', component: addbankaccount, name: 'addbankaccount', meta: { requiresAuth: true } },
    { path: '/updatebankaccount', component: updatebankaccount, name: 'updatebankaccount', meta: { requiresAuth: true } },
    { path: '/booking/category/edit', component: booking_category_edit, name: 'booking_category_edit', meta: { requiresAuth: true } }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { top: 0 }
    }
})

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)

const authStore = useAuthStore(pinia)
authStore.loadFromLocalStorage()

router.beforeEach((to) => {
    if (to.meta.requiresAuth && !authStore.isAuthenticated()) {
        return { name: 'login', query: { redirect: to.fullPath } }
    }
    if (to.name === 'login' && authStore.isAuthenticated()) {
        return { name: 'index' }
    }
    return true
})

app.use(router)

watch(
    () => ({
        authenticated: authStore.authenticated,
        email: authStore.email,
        password: authStore.password,
        firstname: authStore.firstname,
        lastname: authStore.lastname,
        iduser: authStore.iduser,
        permissions: authStore.permissions
    }),
    (state) => localStorage.setItem('auth', JSON.stringify(state)),
    { deep: true }
)

app.mount('#app')